import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'

Vue.config.productionTip = false

import '@/assets/icomoon/style.css'
import '@/assets/css/Main.css'

import Notifications from 'vue-notification'
Vue.use(Notifications)

import VueFilterDateFormat from 'vue-filter-date-format'
Vue.use(VueFilterDateFormat)

import CKEditor from 'ckeditor4-vue';
Vue.use( CKEditor );

var VueCookie = require('vue-cookie')
Vue.use(VueCookie)

var infiniteScroll =  require('vue-infinite-scroll');
Vue.use(infiniteScroll)

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

import { CHART_CONFIG } from '../chart-setting'
Vue.prototype.$chart_config = CHART_CONFIG

import Global from './Global.vue'
Vue.prototype.$Global = Global

import { CONFIG } from '../config'
import Qs from 'qs'
Vue.prototype.Qs = Qs
import axios from 'axios'
Vue.prototype.$http = axios

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    config.headers["Access-Control-Allow-Origin"]="*"
    // console.log("axios.interceptors = ",config.headers['Content-Type'])
    
    if(!config.headers['Content-Type']){
      config.headers['Content-Type']='application/x-www-form-urlencoded'  
    }
  
    if(!config.url.includes("pmMemberLogin") && !config.url.includes("loginByAuth")) {
      config.headers["token"]= sessionStorage.getItem('manageMemberToken')
    }
    config.url = CONFIG.API_URL+config.url;

    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    if (response.data.code == '990') {
      alert(response.data.msg)
      location.href = location.origin+location.pathname + '#/login'
    }
    return response;
  }, function (error) {
    // Do something with response error
    if(error&&error.response&&error.response.data.State=="999"){
      //alert(error.response.data.ErrorMessage)
    if(!location.hash.includes("login")) {
      alert("使用者連線逾時或尚未登入, 請重新登入")
    }
      location.href = location.origin+location.pathname + '#/login'
    }
    return Promise.reject(error);
  });

Vue.prototype.$system = {
  system:false,
  operation:false,
  dean:false
}

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

/*
import 'mathlive';
const mf = document.querySelector('#formula');
const latexField = document.querySelector('#latex');

latexField.addEventListener('input', () => mf.setValue(latexField.value));

function onMathfieldInput() {
// Output MathJSON representation of the expression
console.clear();
console.log('MathJSON expression', mf.expression.json);
// Update raw LaTeX value
latexField.value = mf.value;
}

mf.addEventListener('input', onMathfieldInput);
onMathfieldInput();
*/